import { TranslationLocale } from '../../../lib/types/enums/translation/translation.enum'
import { EnrollmentCharacteristic } from '../../../lib/types/models/enrollment-characteristics/enrollment-characteristics'
import { EnrollmentCharacteristicsInput } from '../../../lib/types/models/enrollment-characteristics/enrollment-characteristics-input'

export function getCharacteristicTranslation(
  characteristic: Pick<EnrollmentCharacteristic, 'translations'>,
  locale: TranslationLocale
): string | undefined {
  return characteristic.translations?.find((t) => t.locale === locale)?.value
}

// Display name = French translation (base language)
export function getCharacteristicName(
  characteristic: Pick<EnrollmentCharacteristic, 'translations'>
): string {
  return getCharacteristicTranslation(characteristic, TranslationLocale.FR) ?? ''
}

export function mapEnrollmentCharacteristicToInput(
  characteristic: EnrollmentCharacteristic
): EnrollmentCharacteristicsInput {
  return {
    translations: characteristic.translations ?? []
  }
}
